import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { ButtonLink } from "../../../../components/ui/button";
import { LANDING_IMAGES } from "../../../../constants/landing-images";
import type { RouteMap } from "../../types";

type LandingHeroSectionProps = {
  routes: RouteMap;
  scrollToSection: (id: string) => void;
};

export const LandingHeroSection: React.FC<LandingHeroSectionProps> = ({
  routes,
}) => (
  <section
    id="home"
    className="relative pt-24 pb-20 lg:pt-32 lg:pb-32 overflow-hidden bg-neutral-900"
  >
    <div className="absolute inset-0 z-0 opacity-40 mix-blend-overlay">
      <img
        src={LANDING_IMAGES.hero}
        alt="Contractor using tablet software"
        className="w-full h-full object-cover object-center filter grayscale"
        width={1920}
        height={1080}
        decoding="async"
        fetchPriority="high"
      />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center items-center text-center">
      <div className="max-w-4xl pt-10">
        <motion.div
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <span className="inline-block py-1.5 px-4 rounded-full bg-premium-500/20 border border-premium-400/30 text-premium-100 font-semibold text-sm mb-8 uppercase tracking-wider backdrop-blur-sm shadow-sm">
            For sole trades and crews
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-extrabold text-white leading-tight mb-8 tracking-tight font-display">
            Run a trade business <br className="hidden sm:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-premium-400 to-premium-500">
              for $9/month
            </span>
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl text-neutral-300 mb-12 max-w-3xl mx-auto leading-relaxed font-light">
            Get found. Take quotes. Keep photos and licenses in one place.
          </p>

          <div className="flex flex-col items-center gap-4">
            <ButtonLink
              to={routes.signup}
              size="lg"
              variant="premium"
              className="w-full sm:w-auto min-w-[280px] px-8 py-4 text-lg flex items-center justify-center group"
            >
              Start 30-day trial
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </ButtonLink>
            <div className="flex items-center text-neutral-400 text-sm font-medium mt-2">
              <CheckCircle2 className="w-4 h-4 mr-1.5 text-premium-500" />
              Chat for a minute. No card to start.
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
